import React from 'react';
import type { ToastVariant } from './Toast';

export interface ToastAction {
  label: string;
  onClick: () => void;
}

export interface ShowToastOptions {
  message: string;
  variant?: ToastVariant;
  durationMs?: number;
  actions?: ToastAction[];
}

export interface ToastContextValue {
  showToast: (options: ShowToastOptions) => void;
}

export const ToastContext = React.createContext<ToastContextValue | null>(null);
